import { useState, useEffect } from 'react';

export const useOnlineStatus = (): { isOnline: boolean } => {
  const [isOnline, setOnlineStatus] = useState<boolean>(
    typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true,
  );

  useEffect(() => {
    const setOnline = () => setOnlineStatus(true);
    const setOffline = () => setOnlineStatus(false);

    window.addEventListener('offline', setOffline, { passive: true });
    window.addEventListener('online', setOnline, { passive: true });

    return () => {
      window.removeEventListener('offline', setOffline);
      window.removeEventListener('online', setOnline);
    };
  }, []);
  return { isOnline };
};
